import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';

export default function Onboarding() {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      title: 'Snabb leverans',
      description: 'Få order direkt och leverera snabbt till nöjda kunder',
      image: 'https://public.readdy.ai/ai/img_res/1cf57aa407772b4db50b2ae79553c3d3.jpg',
    },
    {
      title: 'Canlı navigering',
      description: 'Optimerade rutter och realtidsnavigering för varje leverans',
      image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20GPS%20navigation%20map%20with%20route%20pins%20and%20location%20markers%2C%203D%20isometric%20perspective%2C%20clean%20interface%20design%2C%20red%20and%20blue%20color%20scheme%2C%20high-detail%20rendering%2C%20technology%20concept%2C%20isolated%20on%20white%20background%2C%20centered%20composition%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame&width=300&height=300&seq=onb2&orientation=squarish',
    },
    {
      title: 'Tjäna mer',
      description: 'Transparent betalning, bonusar och flexibla arbetstider',
      image: 'https://readdy.ai/api/search-image?query=Stack%20of%20Swedish%20krona%20banknotes%20and%20coins%20with%20upward%20growth%20arrow%2C%20financial%20success%20concept%2C%203D%20realistic%20rendering%2C%20vibrant%20colors%20with%20red%20and%20blue%20accents%2C%20clean%20professional%20style%2C%20isolated%20on%20white%20background%2C%20centered%20composition%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame&width=300&height=300&seq=onb3&orientation=squarish',
    },
  ];
  
  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      navigate('/permissions');
    }
  };
  
  const handleSkip = () => {
    navigate('/permissions');
  };
  
  return (
    <div className="relative h-screen bg-white flex flex-col">
      <button
        onClick={handleSkip}
        className="absolute top-6 right-6 z-10 text-sm font-semibold text-gray-600 hover:text-gray-900"
      >
        Hoppa över
      </button>
      
      <div className="flex-1 flex flex-col items-center justify-center px-6">
        <div className="w-full max-w-sm">
          <div className="mb-12 overflow-hidden rounded-3xl">
            <img
              src={slides[currentSlide].image}
              alt={slides[currentSlide].title}
              className="w-full h-72 object-cover"
            />
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 text-center mb-3">
            {slides[currentSlide].title}
          </h2>
          <p className="text-base text-gray-600 text-center mb-8">
            {slides[currentSlide].description}
          </p>
          
          <div className="flex justify-center gap-2 mb-8">
            {slides.map((_, index) => (
              <div
                key={index}
                className={`h-2 rounded-full transition-all ${
                  index === currentSlide ? 'w-8 bg-[#E31837]' : 'w-2 bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
      
      <div className="px-6 pb-8">
        <Button
          onClick={handleNext}
          variant="primary"
          size="large"
          fullWidth
        >
          {currentSlide < slides.length - 1 ? 'Nästa' : 'Kom igång'}
        </Button>
      </div>
    </div>
  );
}
